<template>
    <div class="toast" v-if="visible">
      {{ message }}
    </div>
  </template>
   
  <script>
  export default {
    data() {
      return {
        visible: false,
        message: '',
        timer: null
      };
    },
    methods: {
      show(message, duration = 2000) {
        this.message = message;
        this.visible = true;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.visible = false;
        }, duration);
      }
    }
  };
  </script>
   
  <style scoped>
  .toast {
    position: fixed;
    top: 88px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.6);
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    z-index: 1000;
  }
  </style>